import React from "react";
import { HistoricoProducaoProvider } from "./context/HistoricoProducaoContext";
import HistoricoProducaoFilters from "./components/HistoricoProducaoFilters";
import HistoricoProducaoTable from "./components/HistoricoProducaoTable";

const HistoricoProducaoContent: React.FC = () => {
  return (
    <div className="space-y-6">
      <HistoricoProducaoFilters />
      <HistoricoProducaoTable />
    </div>
  );
};

const HistoricoProducao: React.FC = () => {
  return (
    <HistoricoProducaoProvider>
      <HistoricoProducaoContent />
    </HistoricoProducaoProvider>
  );
};

export default HistoricoProducao;
